// extracted by mini-css-extract-plugin
export default {"root":"Preloader_root__WJ1NO","cat":"Preloader_cat__XV+1f"};